import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginButton from "./components/LoginButton";
import { Sidebar } from "./components/SideBar";
import { TenantProvider } from "./contexts/TenantProvider";
import Home from "./pages/Home";
import Secrets from "./pages/Secrets";
import Modeler from "./pages/Modeler";
import Dashboards from "./pages/Dashboards";
import Forms from "./pages/Forms";
import FormBuilder from "./pages/FormBuilder";
import ProcessInstances from "./pages/ProcessInstances";
import ProcessInstanceDetail from "./pages/ProcessInstanceDetail";

export const App: React.FC = () => {
  const { isLoading, isAuthenticated} = useAuth0();

  if (isLoading) return <div>Carregando...</div>;

  return (
    <Router>
      <div>
        {!isAuthenticated && <LoginButton />}
        {isAuthenticated && (
          <TenantProvider>
            <Sidebar />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/secrets" element={<Secrets />} />
              <Route path="/forms" element={<Forms />} />
              <Route path="/form-builder" element={<FormBuilder />} />
              <Route path="/modeler" element={<Modeler />} />
              <Route path="/process-instances" element={<ProcessInstances />} />
              <Route path="/process-instances/:instanceId" element={<ProcessInstanceDetail />} />
              <Route path="/dashboards" element={<Dashboards />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </TenantProvider>
        )}
      </div>
    </Router>
  );
};
